import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { ErrorWithRetry, LoadingMessage } from "../components/UiStates";
import { useLanguage } from "../lib/LanguageContext";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";
import { Input } from "../components/ui/Input";
import { APP_ROUTES, resolveHomePath, resolvePostAuthPath } from "../routing/routes";
const Login = () => {
    const { t } = useLanguage();
    const { login, session, isAuthenticated, isAuthReady } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("user@example.com");
    const [password, setPassword] = useState("password");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!isAuthReady || !isAuthenticated)
            return;
        void navigate(resolveHomePath(session), { replace: true });
    }, [isAuthReady, isAuthenticated, session, navigate]);
    const submit = async () => {
        setLoading(true);
        setError("");
        const result = await login(email, password);
        setLoading(false);
        if (!result.ok) {
            setError(result.message ?? t("auth.errorLogin"));
            return;
        }
        void navigate(resolvePostAuthPath(result.user));
    };
    const onSubmit = async (e) => {
        e.preventDefault();
        await submit();
    };
    return (_jsx("div", { className: "flex min-h-[calc(100dvh-3.5rem)] items-center justify-center bg-gradient-to-br from-purple-50 via-background to-blue-50 px-3 py-10 dark:from-background dark:via-background dark:to-slate-900", children: _jsxs(Card, { className: "w-full max-w-md border-border/80 shadow-lg", children: [_jsx("h1", { className: "mb-6 text-center text-2xl font-bold text-foreground", children: t("auth.loginTitle") }), _jsxs("form", { className: "space-y-4", onSubmit: onSubmit, children: [_jsxs("div", { className: "space-y-2", children: [_jsx("label", { className: "block text-sm font-medium text-foreground", htmlFor: "login-email", children: t("auth.email") }), _jsx(Input, { id: "login-email", value: email, onChange: (e) => setEmail(e.target.value), disabled: loading, autoComplete: "email", inputMode: "email" })] }), _jsxs("div", { className: "space-y-2", children: [_jsx("label", { className: "block text-sm font-medium text-foreground", htmlFor: "login-password", children: t("auth.password") }), _jsx(Input, { id: "login-password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), disabled: loading, autoComplete: "current-password" })] }), loading ? _jsx(LoadingMessage, { text: t("auth.loggingIn") }) : null, error ? _jsx(ErrorWithRetry, { message: error, onRetry: () => void submit(), disabled: loading }) : null, _jsx(Button, { type: "submit", className: "w-full", disabled: loading, children: t("auth.submitLogin") })] }), _jsxs("p", { className: "mt-6 text-center text-sm text-muted-foreground", children: [t("auth.noAccount"), " ", _jsx(Link, { to: APP_ROUTES.register, className: "font-medium text-purple-600 hover:underline dark:text-purple-400", children: t("auth.linkRegister") })] })] }) }));
};
export default Login;
